import CustomerId                   from "../../../../domain/customer/CustomerId";
import Date                         from "../../../../domain/fundamentals/date/Date";
import CurrentPage                  from "../../../../domain/fundamentals/pagination/CurrentPage";
import CustomerRecord               from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordId             from "../../../../domain/record/customer/CustomerRecordId";
import CustomerRecordRepository     from "../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecords              from "../../../../domain/record/customer/CustomerRecords";
import CustomerRecordTemplate       from "../../../../domain/record/customer/CustomerRecordTemplate";
import CustomerRecordWidget         from "../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetItem     from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import { ApiClient }                from "../../../configure/ApiClientConfig";
import {
  setCustomerRecordAction, setCustomerRecordDateAction,
  setCustomerRecordWidgetAction,
  setCustomerRecordWidgetItemAction
} from "../../../redux/record/customer/CustomerRecordAction";
import { setCustomerRecordsAction } from "../../../redux/record/customer/CustomerRecordsAction";

class CustomerRecordDataSource implements CustomerRecordRepository {
  constructor(private readonly dispatch) {
  }

  findByPage(customerId: CustomerId, current: CurrentPage) {
    return ApiClient.get("/customer/records", {
      params: {
        customerId: customerId.value,
        page: current.value,
      }
    })
  }

  findBy(customerRecordId: CustomerRecordId) {
    return ApiClient.get("/customer/record", {
      params: {
        customerRecordId: customerRecordId.value,
      }
    })
  }

  register(customerId: CustomerId, customerRecord: CustomerRecord) {
    const template: CustomerRecordTemplate = customerRecord.template;
    return ApiClient.post(`/customer/record/${ customerId.value }`, {
      date: customerRecord.date.asISOText(),
      template: {
        id: template.id.value,
        revision: template.revision.value,
        name: template.name.value,
        widgets: template.widgets.toList().map(widget => ({
          id: widget.id.value,
          widgetId: widget.widgetId.value,
          type: widget.type.value,
          title: widget.title.value,
          value: widget.value.value,
          coordinate: {
            x: widget.coordinate.x,
            y: widget.coordinate.y,
          },
          items: widget.items.toList().map(item => ({
            id: item.id.value,
            widgetItemId: item.widgetItemId.value,
            title: item.title.value,
            value: item.value.value,
          }))
        }))
      }
    });
  }

  update(customerId: CustomerId, customerRecord: CustomerRecord) {
    const template: CustomerRecordTemplate = customerRecord.template;
    return ApiClient.put(`/customer/record/${ customerId.value }`, {
      id: customerRecord.id.value,
      date: customerRecord.date.asISOText(),
      template: {
        id: template.id.value,
        revision: template.revision.value,
        name: template.name.value,
        widgets: template.widgets.toList().map(widget => ({
          id: widget.id.value,
          widgetId: widget.widgetId.value,
          type: widget.type.value,
          title: widget.title.value,
          value: widget.value.value,
          coordinate: {
            x: widget.coordinate.x,
            y: widget.coordinate.y,
          },
          items: widget.items.toList().map(item => ({
            id: item.id.value,
            widgetItemId: item.widgetItemId.value,
            title: item.title.value,
            value: item.value.value,
          }))
        }))
      }
    });
  }

  delete(customerRecordId: CustomerRecordId) {
    return ApiClient.delete("/customer/record", {
      params: {
        customerRecordId: customerRecordId.value,
      }
    })
  }

  countBy(customerId: CustomerId) {
    return ApiClient.get("/customer/record/count", {
      params: {
        customerId: customerId.value,
      }
    });
  }

  setCustomerRecords(customerRecords: CustomerRecords) {
    this.dispatch(setCustomerRecordsAction(customerRecords));
  }

  setCustomerRecord(customerRecord: CustomerRecord) {
    this.dispatch(setCustomerRecordAction(customerRecord));
  }

  setCustomerRecordDate(date: Date) {
    this.dispatch(setCustomerRecordDateAction(date));
  }

  setCustomerRecordWidget(widgetIndex: number, widget: CustomerRecordWidget) {
    this.dispatch(setCustomerRecordWidgetAction(widgetIndex, widget));
  }

  setCustomerRecordWidgetItem(widgetIndex: number, widgetItemIndex: number, widgetItem: CustomerRecordWidgetItem) {
    this.dispatch(setCustomerRecordWidgetItemAction(widgetIndex, widgetItemIndex, widgetItem));
  }
}

export default CustomerRecordDataSource;
